import React, { useState } from "react"
import Pill from "Components/Pill";
import { Grid } from '@mui/material';
import GeofenceSettingsViewGeo from '../geofenceSettingsViewGeo'
import GeofenceSettingsViewGroups from '../geofenceSettingsViewGroups'
import GeofenceSettingsViewUnits from '../geofenceSettingsViewUnits'
import { injectIntl } from 'react-intl';

const GeofenceSettings = (props) => {

    const { intl, mapRef } = props;
    const { messages } = intl;

    const viewGeofence = 'Geofence'
    const viewGeofenceUnits = 'Units'
    const [view, setView] = useState({ name: messages['mapGeofenceSettings_geofences'], id: viewGeofence })


    return (
        <div>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={1}
                style={{ marginBottom: 10 }}
            >
                <Grid item xs>
                    <Pill
                        key={1}
                        textField={'name'}
                        item={{ name: `${messages['mapGeofenceSettings_geofences']}`, id: viewGeofence }}
                        outlined={viewGeofence !== view?.id}
                        onClick={(entity) => {
                            setView(entity);
                        }}
                        style={{ border: '0', margin: '2px 0', width: '100%' }}
                        label="pill-label-text"
                        colorField="default"
                        colorSelection={'66BB6A'}
                    />
                </Grid>
                <Grid item xs>
                    <Pill
                        key={2}
                        textField={'name'}
                        item={{ name: `${messages['mapGeofenceSettings_units']}`, id: viewGeofenceUnits }}
                        outlined={viewGeofenceUnits !== view?.id}
                        onClick={(entity) => {
                            setView(entity);
                        }}
                        style={{ border: '0', margin: '2px 0', width: '100%' }}
                        label="pill-label-text"
                        colorField="default"
                        colorSelection={'66BB6A'}
                    />
                </Grid>
            </Grid>

            <div>
                {
                    view?.id == viewGeofence
                    &&
                    <GeofenceSettingsViewGeo mapRef={mapRef} />
                }
                {
                    view?.id == viewGeofenceUnits
                    &&
                    <GeofenceSettingsViewUnits mapRef={mapRef} />
                }
            </div>
        </div>
    )
}

export default injectIntl(GeofenceSettings)